<template>
  <v-menu
    v-model="showMenu"
    :close-on-content-click="false"
    :nudge-width="options.width"
    :position-x="x"
    :position-y="y"
    absolute
    offset-y
    origin="center center"
    transition="scale-transition"
  >
    <v-card
      elevation="0"
      width="320"
      max-width="320"
      max-height="450"
      min-height="400"
      class="px-0 py-2 overflow-y-auto"
    >
      <!-- !! 상단 타이틀 : 2021.2.18 보기 흉해서 가려버림 -->
      <!-- <v-row
        align="center"
        justify="start"
        class="ma-0 pa-0"
      >
        <v-col cols="12" class="text-center">
          <span>
            <v-icon color="primary" large>mdi-alpha-l-box-outline</v-icon>
            <v-icon color="primary" large>mdi-alpha-a-box-outline</v-icon>
            <v-avatar size="46">
              <img alt="lawork logo" src="@/assets/logo.png">
            </v-avatar>
            <v-icon color="primary" large>mdi-alpha-o-box-outline</v-icon>
            <v-icon color="primary" large>mdi-alpha-r-box-outline</v-icon>
            <v-icon color="primary" large>mdi-alpha-k-box-outline</v-icon>
          </span>
        </v-col>
      </v-row>
      <v-divider class="my-1"></v-divider> -->

      <!-- !! 바로가기 테스트 -->
      <!-- <v-row
        align="center"
        justify="start"
        class="ma-0 pa-0"
      >
        <template v-for="(s, i) in shortcuts">
          <v-col
            :Key="i"
            cols="12" lg="3" md="3" sm="3" xs="6"
            class="ml-2 mr-3 my-0 pa-0"
          >
            <v-hover v-slot:default="{ hover }">
              <v-card
                elevation="0"
                min-width="95"
                min-height="78"
                :color="hover ? 'blue lighten-5' : ''"
                style="cursor: pointer;"
                class="text-center mx-1 my-1 pt-4"
                @click="goUrlDirect(s.url)"
              >
                <v-icon
                  v-show="!s.svg"
                  class="pb-2"
                  :color="s.color ? s.color : ''"
                >{{ s.icon }}</v-icon>
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-row no-gutters align="center" justify="center">
                      <v-img
                        :src="s.svg"
                        width="24"
                        height="24"
                        contain
                        class="mb-2"
                      ></v-img>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <p class="text-caption">{{ s.text }}</p>
                  </v-col>
                </v-row>
              </v-card>
            </v-hover>
          </v-col>
        </template>
      </v-row>
      <v-divider class="my-1"></v-divider> -->

      <!-- !! 바로가기 1 -->
      <v-row
        align="center"
        justify="start"
        class="ma-0 pa-0"
      >
        <template v-for="(s, i) in shortcuts1">
          <v-col
            :Key="i"
            cols="12" lg="3" md="3" sm="3" xs="6"
            class="ml-2 mr-3 my-0 pa-0"
          >
            <v-hover v-slot:default="{ hover }">
              <v-card
                elevation="0"
                min-width="95"
                min-height="78"
                :color="hover ? 'blue lighten-5' : ''"
                style="cursor: pointer;"
                class="text-center mx-1 my-1 pt-4"
                @click="goUrlDirect(s.url)"
              >
                <!-- !![2021.8.3] svg 이미지 방식으로 변경함 -->
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-row no-gutters align="center" justify="center">
                      <v-img
                        :src="s.svg"
                        width="24"
                        height="24"
                        contain
                        class="mb-2"
                      ></v-img>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <p class="text-caption">{{ s.text }}</p>
                  </v-col>
                </v-row>
              </v-card>
            </v-hover>
          </v-col>
        </template>
      </v-row>
      <v-divider class="my-1"></v-divider>

      <!-- !! 바로가기 4, 5 주의:[2021.8.3 신설] -->
      <v-row
        align="center"
        justify="start"
        class="ma-0 pa-0"
      >
        <template v-for="(s, i) in shortcuts4">
          <v-col
            :Key="i"
            cols="12" lg="3" md="3" sm="3" xs="6"
            class="ml-2 mr-3 my-0 pa-0"
          >
            <v-hover v-slot:default="{ hover }">
              <v-card
                elevation="0"
                min-width="95"
                min-height="78"
                :color="hover ? 'blue lighten-5' : ''"
                style="cursor: pointer;"
                class="text-center mx-1 my-1 pt-4"
                @click="goUrlDirect(s.url)"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-row no-gutters align="center" justify="center">
                      <v-img
                        :src="s.svg"
                        width="24"
                        height="24"
                        contain
                        class="mb-2"
                      ></v-img>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <p class="text-caption">{{ s.text }}</p>
                  </v-col>
                </v-row>
              </v-card>
            </v-hover>
          </v-col>
        </template>
      </v-row>
      <v-row
        align="center"
        justify="start"
        class="ma-0 pa-0"
      >
        <template v-for="(s, i) in shortcuts5">
          <v-col
            :Key="i"
            cols="12" lg="3" md="3" sm="3" xs="6"
            class="ml-2 mr-3 my-0 pa-0"
          >
            <v-hover v-slot:default="{ hover }">
              <v-card
                elevation="0"
                min-width="95"
                min-height="78"
                :color="hover ? 'blue lighten-5' : ''"
                style="cursor: pointer;"
                class="text-center mx-1 my-1 pt-4"
                @click="goUrlDirect(s.url)"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-row no-gutters align="center" justify="center">
                      <v-img
                        :src="s.svg"
                        width="24"
                        height="24"
                        contain
                        class="mb-2"
                      ></v-img>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <p class="text-caption">{{ s.text }}</p>
                  </v-col>
                </v-row>
              </v-card>
            </v-hover>
          </v-col>
        </template>
      </v-row>
      <v-divider class="my-1"></v-divider>

      <!-- !! 바로가기 2 -->
      <v-row
        align="center"
        justify="start"
        class="ma-0 pa-0"
      >
        <template v-for="(s, i) in shortcuts2">
          <v-col
            :Key="i"
            cols="12" lg="3" md="3" sm="3" xs="6"
            class="ml-2 mr-3 my-0 pa-0"
          >
            <v-hover v-slot:default="{ hover }">
              <v-card
                elevation="0"
                min-width="95"
                min-height="78"
                :color="hover ? 'blue lighten-5' : ''"
                style="cursor: pointer;"
                class="text-center mx-1 my-1 pt-2"
                @click="doFunc(s.func, s.url)"
              >
                <template v-if="s.svg">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-row no-gutters align="center" justify="center">
                        <v-img
                          :src="s.svg"
                          width="24"
                          height="24"
                          contain
                          class="mb-2"
                        ></v-img>
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <p class="text-caption">{{ s.text }}</p>
                    </v-col>
                  </v-row>
                </template>
                <template v-else>
                  <v-icon
                    class="pb-0"
                    color="primary"
                  >
                    {{ s.icon ? s.icon : 'mdi-warehouse' }}
                  </v-icon>
                  <p class="text-caption">{{ s.text }}</p>
                </template>
              </v-card>
            </v-hover>
          </v-col>
        </template>
      </v-row>
      <v-divider class="my-1"></v-divider>

      <!-- !! 바로가기 3 -->
      <v-row
        align="center"
        justify="start"
        class="ma-0 pa-0"
      >
        <template v-for="(s, i) in shortcuts3">
          <v-col
            :Key="i"
            cols="12" lg="3" md="3" sm="3" xs="6"
            class="ml-2 mr-3 my-0 pa-0"
          >
            <v-hover v-slot:default="{ hover }">
              <v-card
                elevation="0"
                min-width="95"
                min-height="78"
                :color="hover ? 'blue lighten-5' : ''"
                style="cursor: pointer;"
                class="text-center mx-1 my-1 pt-2"
                @click="doFunc(s.func, s.url)"
              >
                <v-icon
                  class="pb-0"
                  color="orange darken-3"
                >
                  {{ s.icon ? s.icon : 'mdi-gavel' }}
                </v-icon>
                <p class="text-caption">{{ s.text }}</p>
              </v-card>
            </v-hover>
          </v-col>
        </template>
      </v-row>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  data: () => ({
    resolve: null, // 이 방법이 너무 참신하다!
    reject: null,
    options: {
      color: 'primary',
      width: 300
    },
    showMenu: false,
    x: 0,
    y: 0,
    // 구분: 바로가기 배열 :: 테스트 용
    shortcuts: [
      {
        text: '실무계산기',
        icon: 'mdi-calculator',
        color: 'primary',
        func: 'openCalculator', // 실행함수
        url: '',
        svg: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaGVpZ2h0PSI0OHB4IiB2aWV3Qm94PSIwIDAgNDggNDgiIHdpZHRoPSI0OHB4IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxyZWN0IGZpbGw9IiNmZmYiIGhlaWdodD0iMTYiIHRyYW5zZm9ybT0icm90YXRlKC05MCAyMCAyNCkiIHdpZHRoPSIxNiIgeD0iMTIiIHk9IjE2Ii8+PHBvbHlnb24gZmlsbD0iIzFlODhlNSIgcG9pbnRzPSIzLDE3IDMsMzEgOCwzMiAxMywzMSAxMywxNyA4LDE2Ii8+PHBhdGggZD0iTTM3LDI0djE0YzAsMS42NTctMS4zNDMsMy0zLDNIMTNsLTEtNWwxLTVoMTR2LTdsNS0xTDM3LDI0eiIgZmlsbD0iIzRjYWY1MCIvPjxwYXRoIGQ9Ik0zNywxMHYxNEgyN3YtN0gxM2wtMS01bDEtNWgyMUMzNS42NTcsNywzNyw4LjM0MywzNywxMHoiIGZpbGw9IiNmYmMwMmQiLz48cGF0aCBkPSJNMTMsMzF2MTBINmMtMS42NTcsMC0zLTEuMzQzLTMtM3YtN0gxM3oiIGZpbGw9IiMxNTY1YzAiLz48cG9seWdvbiBmaWxsPSIjZTUzOTM1IiBwb2ludHM9IjEzLDcgMTMsMTcgMywxNyIvPjxwb2x5Z29uIGZpbGw9IiMyZTdkMzIiIHBvaW50cz0iMzgsMjQgMzcsMzIuNDUgMjcsMjQgMzcsMTUuNTUiLz48cGF0aCBkPSJNNDYsMTAuMTF2MjcuNzhjMCwwLjg0LTAuOTgsMS4zMS0xLjYzLDAuNzhMMzcsMzIuNDV2LTE2LjlsNy4zNy02LjIyQzQ1LjAyLDguOCw0Niw5LjI3LDQ2LDEwLjExeiIgZmlsbD0iIzRjYWY1MCIvPjwvc3ZnPg=='
      },
      {
        text: '판례/법령',
        icon: 'mdi-bank-outline',
        color: 'primary',
        func: 'goUrlDirect',
        url: 'https://glaw.scourt.go.kr/wsjo/intesrch/sjo022.do',
        png: ''
      }
    ],
    // 구분: 바로가기 배열 1
    shortcuts1: [
      // {
      //   text: '구글계정',
      //   url: 'https://myaccount.google.com/personal-info',
      //   icon: 'mdi-google',
      //   color: 'primary'
      // },
      // {
      //   text: 'G메일',
      //   url: 'https://mail.google.com/mail/u/0/#inbox',
      //   icon: 'mdi-gmail',
      //   color: 'success'
      // },
      // {
      //   text: '드라이브',
      //   url: 'https://drive.google.com/drive/u/0/my-drive',
      //   icon: 'mdi-google-drive',
      //   color: 'warning'
      // },
      // {
      //   text: '구글검색',
      //   url: 'https://www.google.co.kr/webhp?tab=rw&authuser=0',
      //   icon: 'mdi-magnify',
      //   color: 'light-blue accent-2'
      // },
      // {
      //   text: '구글지도',
      //   url: 'https://www.google.co.kr/maps/',
      //   icon: 'mdi-google-maps',
      //   color: 'lime darken-3'
      // },
      // {
      //   text: 'YouTube',
      //   url: 'https://www.youtube.com/?gl=KR&tab=r1',
      //   icon: 'mdi-youtube',
      //   color: 'error'
      // },
      // {
      //   text: '캘린더',
      //   url: 'https://calendar.google.com/calendar/u/0/r?tab=rc',
      //   icon: 'mdi-calendar',
      //   color: 'purple'
      // }
      // !![2021.8.3] 구글 아이콘을 컬러 svg 이미지로 교체
      {
        text: '구글검색',
        url: 'https://www.google.com/',
        svg: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDEyOCAxMjgiIGlkPSJTb2NpYWxfSWNvbnMiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDEyOCAxMjgiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxnIGlkPSJfeDMxX19zdHJva2UiPjxnIGlkPSJHb29nbGUiPjxyZWN0IGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBoZWlnaHQ9IjEyOCIgd2lkdGg9IjEyOCIvPjxwYXRoIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI3LjU4NSw2NGMwLTQuMTU3LDAuNjktOC4xNDMsMS45MjMtMTEuODgxTDcuOTM4LDM1LjY0OCAgICBDMy43MzQsNDQuMTgzLDEuMzY2LDUzLjgwMSwxLjM2Niw2NGMwLDEwLjE5MSwyLjM2NiwxOS44MDIsNi41NjMsMjguMzMybDIxLjU1OC0xNi41MDNDMjguMjY2LDcyLjEwOCwyNy41ODUsNjguMTM3LDI3LjU4NSw2NCIgZmlsbD0iI0ZCQkMwNSIgZmlsbC1ydWxlPSJldmVub2RkIi8+PHBhdGggY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNjUuNDU3LDI2LjE4MmM5LjAzMSwwLDE3LjE4OCwzLjIsMjMuNTk3LDguNDM2TDEwNy42OTgsMTYgICAgQzk2LjMzNyw2LjEwOSw4MS43NzEsMCw2NS40NTcsMEM0MC4xMjksMCwxOC4zNjEsMTQuNDg0LDcuOTM4LDM1LjY0OGwyMS41NjksMTYuNDcxQzM0LjQ3NywzNy4wMzMsNDguNjQ0LDI2LjE4Miw2NS40NTcsMjYuMTgyIiBmaWxsPSIjRUE0MzM1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02NS40NTcsMTAxLjgxOGMtMTYuODEyLDAtMzAuOTc5LTEwLjg1MS0zNS45NDktMjUuOTM3ICAgIEw3LjkzOCw5Mi4zNDlDMTguMzYxLDExMy41MTYsNDAuMTI5LDEyOCw2NS40NTcsMTI4YzE1LjYzMiwwLDMwLjU1Ny01LjU1MSw0MS43NTgtMTUuOTUxTDg2Ljc0MSw5Ni4yMjEgICAgQzgwLjk2NCw5OS44Niw3My42ODksMTAxLjgxOCw2NS40NTcsMTAxLjgxOCIgZmlsbD0iIzM0QTg1MyIgZmlsbC1ydWxlPSJldmVub2RkIi8+PHBhdGggY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTI2LjYzNCw2NGMwLTMuNzgyLTAuNTgzLTcuODU1LTEuNDU3LTExLjYzNkg2NS40NTd2MjQuNzI3ICAgIGgzNC4zNzZjLTEuNzE5LDguNDMxLTYuMzk3LDE0LjkxMi0xMy4wOTIsMTkuMTNsMjAuNDc0LDE1LjgyOEMxMTguOTgxLDEwMS4xMjksMTI2LjYzNCw4NC44NjEsMTI2LjYzNCw2NCIgZmlsbD0iIzQyODVGNCIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9nPjwvZz48L3N2Zz4=',
        color: 'primary'
      },
      {
        text: 'G메일',
        url: 'https://mail.google.com/mail/u/0/#inbox',
        svg: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaGVpZ2h0PSI0OHB4IiB2aWV3Qm94PSIwIDAgNDggNDgiIHdpZHRoPSI0OHB4IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik00NSwxNi4ybC01LDIuNzVsLTUsNC43NUwzNSw0MGg3YzEuNjU3LDAsMy0xLjM0MywzLTNWMTYuMnoiIGZpbGw9IiM0Y2FmNTAiLz48cGF0aCBkPSJNMywxNi4ybDMuNjE0LDEuNzFMMTMsMjMuN1Y0MEg2Yy0xLjY1NywwLTMtMS4zNDMtMy0zVjE2LjJ6IiBmaWxsPSIjMWU4OGU1Ii8+PHBvbHlnb24gZmlsbD0iI2U1MzkzNSIgcG9pbnRzPSIzNSwxMS4yIDI0LDE5LjQ1IDEzLDExLjIgMTIsMTcgMTMsMjMuNyAyNCwzMS45NSAzNSwyMy43IDM2LDE3Ii8+PHBhdGggZD0iTTMsMTIuMjk4VjE2LjJsMTAsNy41VjExLjJMOS44NzYsOC44NTlDOS4xMzIsOC4zMDEsOC4yMjgsOCw3LjI5OCw4aDBDNC45MjQsOCwzLDkuOTI0LDMsMTIuMjk4eiIgZmlsbD0iI2M2MjgyOCIvPjxwYXRoIGQ9Ik00NSwxMi4yOThWMTYuMmwtMTAsNy41VjExLjJsMy4xMjQtMi4zNDFDMzguODY4LDguMzAxLDM5Ljc3Miw4LDQwLjcwMiw4aDAgQzQzLjA3Niw4LDQ1LDkuOTI0LDQ1LDEyLjI5OHoiIGZpbGw9IiNmYmMwMmQiLz48L3N2Zz4=',
        color: 'primary'
      },
      {
        text: '드라이브',
        url: 'https://drive.google.com/drive/u/0/my-drive',
        svg: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMC8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvVFIvMjAwMS9SRUMtU1ZHLTIwMDEwOTA0L0RURC9zdmcxMC5kdGQnPjxzdmcgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMzIgMzIiIGhlaWdodD0iMzJweCIgaWQ9IkxheWVyXzEiIHZlcnNpb249IjEuMCIgdmlld0JveD0iMCAwIDMyIDMyIiB3aWR0aD0iMzJweCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGc+PHBvbHlsaW5lIGZpbGw9IiM1MzdBQkQiIHBvaW50cz0iMzEuODY4LDIxIDkuODY4LDIxIDQuODY4LDMwIDI2LjU1NiwzMCAgIi8+PHBvbHlsaW5lIGZpbGw9IiMyRUI2NzIiIHBvaW50cz0iMTAuOTYyLDIgLTAuMDM4LDIwIDQuOTYyLDMwIDE1LjY4MywxMC4zNDUgICIvPjxwb2x5bGluZSBmaWxsPSIjRkVEMTRCIiBwb2ludHM9IjIwLjk2MiwyIDEwLjk2MiwyIDIxLjcxMiwyMSAzMS45NjIsMjEgMjAuOTYyLDIgICIvPjwvZz48Zy8+PGcvPjxnLz48Zy8+PGcvPjxnLz48L3N2Zz4=',
        color: 'primary'
      },
      {
        text: '구글지도',
        url: 'https://www.google.co.kr/maps/',
        svg: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pjxzdmcgdmlld0JveD0iMCAwIDE1MCAxNTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxwYXRoIGQ9Ik04OS43NywxMC40Yy00LjQtMS4zOS05LjA4LTIuMTUtMTMuOTQtMi4xNWMtMTQuMTgsMC0yNi44Nyw2LjQxLTM1LjMzLDE2LjQ4bDIxLjgsMTguMzRMODkuNzcsMTAuNHoiIGZpbGw9IiMxYTczZTgiLz48cGF0aCBkPSJNNDAuNDksMjQuNzNjLTYuNzQsOC4wMi0xMC44MSwxOC4zNy0xMC44MSwyOS42NmMwLDguNjgsMS43MywxNS43MSw0LjU3LDIyLjAxbDI4LjA0LTMzLjMzTDQwLjQ5LDI0LjczeiIgZmlsbD0iI2VhNDMzNSIvPjxwYXRoIGQ9Ik03NS44MywzNi43NWM5Ljc1LDAsMTcuNjUsNy45LDE3LjY1LDE3LjY1YzAsNC4zNC0xLjU3LDguMzItNC4xNywxMS4zOWMwLDAsMTMuOTQtMTYuNTgsMjcuNDctMzIuNjYgICBjLTUuNTktMTAuNzUtMTUuMjgtMTkuMDItMjctMjIuNzNMNjIuMjksNDMuMDdDNjUuNTMsMzkuMiw3MC4zOSwzNi43NSw3NS44MywzNi43NSIgZmlsbD0iIzQyODVmNCIvPjxwYXRoIGQ9Ik03NS44Myw3Mi4wNGMtOS43NSwwLTE3LjY1LTcuOS0xNy42NS0xNy42NWMwLTQuMzEsMS41NS04LjI2LDQuMTEtMTEuMzNMMzQuMjUsNzYuNCAgIGM0Ljc5LDEwLjYzLDEyLjc2LDE5LjE2LDIwLjk3LDI5LjkxTDg5LjMsNjUuNzlDODYuMDcsNjkuNjEsODEuMjMsNzIuMDQsNzUuODMsNzIuMDQiIGZpbGw9IiNmYmJjMDQiLz48cGF0aCBkPSJNODguNjMsMTE3LjM3YzE1LjM5LTI0LjA3LDMzLjM0LTM1LDMzLjM0LTYyLjk4YzAtNy42Ny0xLjg4LTE0LjktNS4xOS0yMS4yNmwtNjEuNTUsNzMuMTggICBjMi42MSwzLjQyLDUuMjQsNy4wNiw3LjgxLDExLjA3YzkuMzYsMTQuNDYsNi43NiwyMy4xMywxMi44LDIzLjEzQzgxLjg2LDE0MC41MSw3OS4yNywxMzEuODMsODguNjMsMTE3LjM3IiBmaWxsPSIjMzRhODUzIi8+PC9zdmc+',
        color: 'primary'
      },
      {
        text: '구글 Meet',
        url: 'https://meet.google.com/?hs=193&pli=1', // 'https://apps.google.com/intl/ko/intl/ko_ALL/meet/',
        svg: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaGVpZ2h0PSI0OHB4IiB2aWV3Qm94PSIwIDAgNDggNDgiIHdpZHRoPSI0OHB4IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxyZWN0IGZpbGw9IiNmZmYiIGhlaWdodD0iMTYiIHRyYW5zZm9ybT0icm90YXRlKC05MCAyMCAyNCkiIHdpZHRoPSIxNiIgeD0iMTIiIHk9IjE2Ii8+PHBvbHlnb24gZmlsbD0iIzFlODhlNSIgcG9pbnRzPSIzLDE3IDMsMzEgOCwzMiAxMywzMSAxMywxNyA4LDE2Ii8+PHBhdGggZD0iTTM3LDI0djE0YzAsMS42NTctMS4zNDMsMy0zLDNIMTNsLTEtNWwxLTVoMTR2LTdsNS0xTDM3LDI0eiIgZmlsbD0iIzRjYWY1MCIvPjxwYXRoIGQ9Ik0zNywxMHYxNEgyN3YtN0gxM2wtMS01bDEtNWgyMUMzNS42NTcsNywzNyw4LjM0MywzNywxMHoiIGZpbGw9IiNmYmMwMmQiLz48cGF0aCBkPSJNMTMsMzF2MTBINmMtMS42NTcsMC0zLTEuMzQzLTMtM3YtN0gxM3oiIGZpbGw9IiMxNTY1YzAiLz48cG9seWdvbiBmaWxsPSIjZTUzOTM1IiBwb2ludHM9IjEzLDcgMTMsMTcgMywxNyIvPjxwb2x5Z29uIGZpbGw9IiMyZTdkMzIiIHBvaW50cz0iMzgsMjQgMzcsMzIuNDUgMjcsMjQgMzcsMTUuNTUiLz48cGF0aCBkPSJNNDYsMTAuMTF2MjcuNzhjMCwwLjg0LTAuOTgsMS4zMS0xLjYzLDAuNzhMMzcsMzIuNDV2LTE2LjlsNy4zNy02LjIyQzQ1LjAyLDguOCw0Niw5LjI3LDQ2LDEwLjExeiIgZmlsbD0iIzRjYWY1MCIvPjwvc3ZnPg==',
        color: 'primary'
      },
      {
        text: '행아웃',
        url: 'https://hangouts.google.com/?hl=ko',
        svg: 'data:image/svg+xml;base64,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',
        color: 'primary'
      }
    ],
    // 구분: 바로가기 배열 2
    shortcuts2: [
      {
        text: '판결서열람',
        icon: '',
        svg: '',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'https://sladmin.scourt.go.kr/common/wcd/wcd.jsp#content'
      },
      {
        text: '전자공탁',
        icon: 'mdi-office-building-marker-outline',
        svg: '',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'https://ekt.scourt.go.kr/'
      },
      {
        text: '전자후견등기',
        icon: 'mdi-store',
        svg: '',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'https://egdrs.scourt.go.kr/'
      },
      {
        text: '가족관계등록',
        icon: 'mdi-account-multiple-plus',
        svg: '',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'http://efamily.scourt.go.kr/index.jsp'
      },
      {
        text: '재외국민가족관계등록',
        icon: 'mdi-hospital-building',
        svg: '',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'http://kfamily.scourt.go.kr/new/dev/main.go'
      },
      {
        text: '인터넷등기소',
        icon: 'mdi-domain',
        svg: '',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'http://www.iros.go.kr/PMainJ.jsp'
      },
      {
        text: '부동산공시가격',
        icon: 'mdi-home-group',
        svg: '',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'https://www.realtyprice.kr:447/notice/main/mainBody.htm'
      },
      {
        text: '부동산실거래가',
        icon: 'mdi-home-assistant',
        svg: '',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'http://rt.molit.go.kr/'
      },
      {
        text: '토지이용',
        icon: 'mdi-home-map-marker',
        svg: '',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'http://luris.molit.go.kr/web/index.jsp'
      },
      {
        text: '정부24',
        icon: '',
        svg: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDEyOCAxMjgiIGhlaWdodD0iMTI4cHgiIGlkPSJMYXllcl8xIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAxMjggMTI4IiB3aWR0aD0iMTI4cHgiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxnPjxnPjxwYXRoIGQ9Ik0yMCw0OGg4di04aC04VjQ4eiBNNTIsNDBoOHYtOGgtOFY0MHogTTY4LDQwaDh2LThoLThWNDB6IE04NCw0MGg4di04aC04VjQweiBNNTIsMjRoOHYtOGgtOFYyNHogTTY4LDI0ICAgIGg4di04aC04VjI0eiBNODQsMjRoOHYtOGgtOFYyNHogTTUyLDcyaDh2LThoLThWNzJ6IE02OCw3Mmg4di04aC04VjcyeiBNODQsNzJoOHYtOGgtOFY3MnogTTUyLDg4aDh2LThoLThWODh6IE04NCw4OGg4di04aC04Vjg4ICAgIHogTTUyLDEwNGg4di04aC04VjEwNHogTTg0LDEwNGg4di04aC04VjEwNHogTTEwOCw5Nmg4di04aC04Vjk2eiBNMTA4LDcydjhoOHYtOEgxMDh6IE0xMDgsMTEyaDh2LThoLThWMTEyeiBNNTIsNTZoOHYtOGgtOFY1NnogICAgIE02OCw1Nmg4di04aC04VjU2eiBNODQsNTZoOHYtOGgtOFY1NnogTTIwLDY0aDh2LThoLThWNjR6IE0yMCw4MGg4di04aC04VjgweiBNMjAsOTZoOHYtOGgtOFY5NnogTTIwLDExMmg4di04aC04VjExMnogTTY4LDg4aDggICAgdi04aC04Vjg4eiIgZmlsbD0iI0IwQkVDNSIvPjwvZz48L2c+PHBhdGggY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTI0LDEyMGMwLDQuNDIyLTMuNTc4LDgtOCw4SDEyYy00LjQyMiwwLTgtMy41NzgtOC04VjMyICBjMC00LjQyMiwzLjU3OC04LDgtOGgyNFY4YzAtNC40MjIsMy41NzgtOCw4LThoNTZjNC40MjIsMCw4LDMuNTc4LDgsOHY0OGg4YzQuNDIyLDAsOCwzLjU3OCw4LDhWMTIweiBNMzYsMzJIMTJ2ODhoMjRWMzJ6IE0xMDAsOCAgSDQ0djExMmgyNFY5Nmg4djI0aDI0Vjh6IE0xMTYsNjRoLTh2NTZoOFY2NHoiIGZpbGw9IiM1NDZFN0EiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'https://www.gov.kr/portal/main'
      }
    ],
    // 구분: 바로가기 배열 3
    shortcuts3: [
      {
        text: '헌법재판소',
        icon: 'mdi-bank',
        svg: '',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'https://www.ccourt.go.kr/cckhome/kor/main/index.do'
      },
      {
        text: '전자헌법재판센터',
        icon: 'mdi-home-flood',
        svg: '',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'https://ecourt.ccourt.go.kr/coelec/websquare/websquare.html?w2xPath=/ui/coelec/main/index.xml'
      },
      {
        text: '법원',
        icon: '',
        svg: '',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'https://www.scourt.go.kr/scourt/index.html'
      },
      {
        text: '전자소송',
        icon: 'mdi-city',
        svg: '',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'https://ecfs.scourt.go.kr/'
      },
      {
        text: '검찰청',
        icon: 'mdi-warehouse',
        svg: '',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'https://www.spo.go.kr/site/spo/main.do'
      },
      {
        text: '경찰청',
        icon: 'mdi-city-variant-outline',
        svg: '',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'https://www.police.go.kr/index.do'
      },
      {
        text: '군사법원',
        icon: 'mdi-domain',
        svg: '',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'https://www.hcaf.mil.kr/user/indexMain.action?siteId=hcaf'
      },
      {
        text: '국가인권위원회',
        icon: 'mdi-garage-variant',
        svg: '',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'https://www.humanrights.go.kr/'
      },
      {
        text: '중앙노동위원회',
        icon: 'mdi-home-city',
        svg: '',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'http://www.nlrc.go.kr/nlrc/main/index_home.go'
      },
      {
        text: '공정거래위원회',
        icon: 'mdi-bank-outline',
        svg: '',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'https://www.ftc.go.kr/'
      },
      {
        text: '출입국외국인정책본부',
        icon: 'mdi-office-building',
        svg: '',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'http://www.immigration.go.kr/immigration/index.do'
      },
      {
        text: '대한상사중재원',
        icon: 'mdi-water-well-outline',
        svg: '',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'http://www.kcab.or.kr/servlet/main/1000'
      }
    ],
    // 구분: 바로가기 배열 4
    // !![2021.8.3 신설]
    shortcuts4: [
      {
        text: '판례법령',
        svg: 'data:image/svg+xml;base64,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',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'https://law.go.kr/LSW/lsSc.do?tabNo=7&menuId=0&subMenu=4'
      }
    ],
    // 구분: 바로가기 배열 5
    // !![2021.8.3 신설]
    shortcuts5: [
      {
        text: '법원서식',
        svg: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDEyOCAxMjgiIGhlaWdodD0iMTI4cHgiIGlkPSJMYXllcl8xIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAxMjggMTI4IiB3aWR0aD0iMTI4cHgiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxnPjxnPjxwYXRoIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTk2LDBIMTZDNy4xNjQsMCwwLDcuMTY0LDAsMTZ2OTZjMCw4LjgzNiw3LjE2NCwxNiwxNiwxNmg0NHYtOCAgICBIMTZjLTQuNDA2LDAtOC0zLjU4Ni04LThWMTZjMC00LjQxNCwzLjU5NC04LDgtOGg4MGM0LjQxNCwwLDgsMy41ODYsOCw4djQ3LjAzMWw4LThWMTZDMTEyLDcuMTY0LDEwNC44MzYsMCw5NiwweiIgZmlsbD0iIzU0NkU3QSIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9nPjwvZz48cGF0aCBkPSJNMTI1LjY1Niw3MkwxMjAsNjYuMzQ0Yy0xLjU2My0xLjU2My0zLjYwOS0yLjM0NC01LjY1Ni0yLjM0NHMtNC4wOTQsMC43ODEtNS42NTYsMi4zNDRsLTM0LjM0NCwzNC4zNDQgIGMtMS41NjMsMS41NjMtNi4zNDIsNy42MDUtNi4zNDQsOS42NTJMNjQsMTI4bDE3LjY1Ni00YzAsMCw4LjA5NC00Ljc4MSw5LjY1Ni02LjM0NGwzNC4zNDQtMzQuMzQ0ICBDMTI4Ljc4MSw4MC4xODgsMTI4Ljc4MSw3NS4xMjEsMTI1LjY1Niw3MnogTTg4LjQ5MiwxMTQuODJjLTAuNDUzLDAuNDMtMi4wMiwxLjQ4OC0zLjkzNCwyLjcwN2wtMTAuMzYzLTEwLjM2MyAgYzEuMDYzLTEuNDU3LDIuMjQ2LTIuOTIyLDIuOTc3LTMuNjQ4bDI1Ljg1OS0yNS44NTlsMTEuMzEzLDExLjMxM0w4OC40OTIsMTE0LjgyeiIgZmlsbD0iIzAzQTlGNCIvPjxwYXRoIGQ9Ik04OCwzMkgyNHYtOGg2NFYzMnoiIGZpbGw9IiNCMEJFQzUiLz48cGF0aCBkPSJNODgsNDhIMjR2LThoNjRWNDh6IiBmaWxsPSIjQjBCRUM1Ii8+PHBhdGggZD0iTTg4LDY0SDI0di04aDY0VjY0eiIgZmlsbD0iI0IwQkVDNSIvPjxwYXRoIGQ9Ik01Niw4MEgyNHYtOGgzMlY4MHoiIGZpbGw9IiNCMEJFQzUiLz48L3N2Zz4=',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'https://help.scourt.go.kr/nm/minwon/doc/DocListAction.work'
      },
      {
        text: '검찰서식',
        svg: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDEyOCAxMjgiIGhlaWdodD0iMTI4cHgiIGlkPSJMYXllcl8xIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAxMjggMTI4IiB3aWR0aD0iMTI4cHgiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxnPjxnPjxwYXRoIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTk2LDBIMTZDNy4xNjQsMCwwLDcuMTY0LDAsMTZ2OTZjMCw4LjgzNiw3LjE2NCwxNiwxNiwxNmg0NHYtOCAgICBIMTZjLTQuNDA2LDAtOC0zLjU4Ni04LThWMTZjMC00LjQxNCwzLjU5NC04LDgtOGg4MGM0LjQxNCwwLDgsMy41ODYsOCw4djQ3LjAzMWw4LThWMTZDMTEyLDcuMTY0LDEwNC44MzYsMCw5NiwweiIgZmlsbD0iIzU0NkU3QSIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9nPjwvZz48cGF0aCBkPSJNMTI1LjY1Niw3MkwxMjAsNjYuMzQ0Yy0xLjU2My0xLjU2My0zLjYwOS0yLjM0NC01LjY1Ni0yLjM0NHMtNC4wOTQsMC43ODEtNS42NTYsMi4zNDRsLTM0LjM0NCwzNC4zNDQgIGMtMS41NjMsMS41NjMtNi4zNDIsNy42MDUtNi4zNDQsOS42NTJMNjQsMTI4bDE3LjY1Ni00YzAsMCw4LjA5NC00Ljc4MSw5LjY1Ni02LjM0NGwzNC4zNDQtMzQuMzQ0ICBDMTI4Ljc4MSw4MC4xODgsMTI4Ljc4MSw3NS4xMjEsMTI1LjY1Niw3MnogTTg4LjQ5MiwxMTQuODJjLTAuNDUzLDAuNDMtMi4wMiwxLjQ4OC0zLjkzNCwyLjcwN2wtMTAuMzYzLTEwLjM2MyAgYzEuMDYzLTEuNDU3LDIuMjQ2LTIuOTIyLDIuOTc3LTMuNjQ4bDI1Ljg1OS0yNS44NTlsMTEuMzEzLDExLjMxM0w4OC40OTIsMTE0LjgyeiIgZmlsbD0iIzAzQTlGNCIvPjxwYXRoIGQ9Ik04OCwzMkgyNHYtOGg2NFYzMnoiIGZpbGw9IiNCMEJFQzUiLz48cGF0aCBkPSJNODgsNDhIMjR2LThoNjRWNDh6IiBmaWxsPSIjQjBCRUM1Ii8+PHBhdGggZD0iTTg4LDY0SDI0di04aDY0VjY0eiIgZmlsbD0iI0IwQkVDNSIvPjxwYXRoIGQ9Ik01Niw4MEgyNHYtOGgzMlY4MHoiIGZpbGw9IiNCMEJFQzUiLz48L3N2Zz4=',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'https://www.spo.go.kr/site/spo/ex/openForm/infoOpenFormList.do'
      },
      {
        text: '헌재서식',
        svg: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDEyOCAxMjgiIGhlaWdodD0iMTI4cHgiIGlkPSJMYXllcl8xIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAxMjggMTI4IiB3aWR0aD0iMTI4cHgiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxnPjxnPjxwYXRoIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTk2LDBIMTZDNy4xNjQsMCwwLDcuMTY0LDAsMTZ2OTZjMCw4LjgzNiw3LjE2NCwxNiwxNiwxNmg0NHYtOCAgICBIMTZjLTQuNDA2LDAtOC0zLjU4Ni04LThWMTZjMC00LjQxNCwzLjU5NC04LDgtOGg4MGM0LjQxNCwwLDgsMy41ODYsOCw4djQ3LjAzMWw4LThWMTZDMTEyLDcuMTY0LDEwNC44MzYsMCw5NiwweiIgZmlsbD0iIzU0NkU3QSIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9nPjwvZz48cGF0aCBkPSJNMTI1LjY1Niw3MkwxMjAsNjYuMzQ0Yy0xLjU2My0xLjU2My0zLjYwOS0yLjM0NC01LjY1Ni0yLjM0NHMtNC4wOTQsMC43ODEtNS42NTYsMi4zNDRsLTM0LjM0NCwzNC4zNDQgIGMtMS41NjMsMS41NjMtNi4zNDIsNy42MDUtNi4zNDQsOS42NTJMNjQsMTI4bDE3LjY1Ni00YzAsMCw4LjA5NC00Ljc4MSw5LjY1Ni02LjM0NGwzNC4zNDQtMzQuMzQ0ICBDMTI4Ljc4MSw4MC4xODgsMTI4Ljc4MSw3NS4xMjEsMTI1LjY1Niw3MnogTTg4LjQ5MiwxMTQuODJjLTAuNDUzLDAuNDMtMi4wMiwxLjQ4OC0zLjkzNCwyLjcwN2wtMTAuMzYzLTEwLjM2MyAgYzEuMDYzLTEuNDU3LDIuMjQ2LTIuOTIyLDIuOTc3LTMuNjQ4bDI1Ljg1OS0yNS44NTlsMTEuMzEzLDExLjMxM0w4OC40OTIsMTE0LjgyeiIgZmlsbD0iIzAzQTlGNCIvPjxwYXRoIGQ9Ik04OCwzMkgyNHYtOGg2NFYzMnoiIGZpbGw9IiNCMEJFQzUiLz48cGF0aCBkPSJNODgsNDhIMjR2LThoNjRWNDh6IiBmaWxsPSIjQjBCRUM1Ii8+PHBhdGggZD0iTTg4LDY0SDI0di04aDY0VjY0eiIgZmlsbD0iI0IwQkVDNSIvPjxwYXRoIGQ9Ik01Niw4MEgyNHYtOGgzMlY4MHoiIGZpbGw9IiNCMEJFQzUiLz48L3N2Zz4=',
        color: 'grey darken-2',
        func: 'goUrlDirect',
        url: 'https://ecourt.ccourt.go.kr/coelec/websquare/websquare.html?w2xPath=/ui/coelec/main/index.xml&menuId=MCID_01_04'
      }
    ]
  }),

  computed: {
    defaultIcon () {
      return 'mdi-apps'
    }
  },

  watch: {
  },

  methods: {
    dummy () {
      console.log('dummy test')
    },
    sbpop (e) {
      // 서버에서 수신받은 에러는 router 에서 가로채기 하므로 띄우지 않도록 if (!e.response) 를 검사한다.
      if (!e.response) this.$store.commit('SB_POP', { msg: e.message })
    },
    // !!중요: 재귀적으로 부모의 $refs 를 탐색하여 target 객체를 찾아 리턴한다.
    // 주로 팝업을 검색하는데 사용!
    async findParentRefs (parent, target) {
      try {
        for (let key in parent.$refs) {
          if (key === target) { // 찾은경우
            return parent.$refs[key]
          }
        }
        // 못찾은 경우 - 부모가 또 있으면 올라간다.
        if (parent.$parent) {
          return await this.findParentRefs(parent.$parent, target)
        } else {
          return null // 못찾으면 null 리턴
        }
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 초기화
    async init () {
    },
    // 메뉴 팝업을 띄우는 함수
    async show (evt) {
      try {
        if (!this.showMenu) { // !! 안전장치 - 이미 열려있으면 다시 열리지 않게 한다.
          evt.preventDefault()
          this.showMenu = false
          this.x = evt.clientX
          this.y = evt.clientY + 30

          this.$nextTick(() => {
            this.showMenu = true
          })
        }
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 구분: 함수실행
    async doFunc (func, url) {
      try {
        if (url) {
          this[func](url)
        } else {
          this[func]()
        }
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 구분: 실무계산기 팝업열기
    async openCalculator () {
      try {
        const target = 'movePop' // 'calcMain'
        const pop = await this.findParentRefs(this.$parent, target)
        if (!pop) throw new Error('팝업창을 열 수 없습니다.')
        await pop.open('실무계산기', { width: 960, height: 670 })
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 구분: 새로 탭을 열고 인자로 전달받은 링크로 이동시키는 함수
    async goUrlDirect (gUrl) {
      try {
        const link = document.createElement('a')
        link.href = gUrl
        link.target = '_blank'
        link.click()
      } catch (e) {
        this.sbpop(e)
      }
    }
  }
}
</script>
